import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import { AuthProvider } from "@/components/auth/AuthProvider";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/auth/Login";
import Index from "@/pages/Index";
import ProprietariosIndex from "@/pages/proprietarios/Index";
import MensagensIndex from "@/pages/mensagens/Index";
import ConexaoIndex from "@/pages/conexao/Index";
import ConfiguracoesIndex from "@/pages/configuracoes/Index";
import ImoveisIndex from "@/pages/imoveis/Index";
import AgendamentosIndex from "@/pages/agendamentos/Index";
import RelatoriosIndex from "@/pages/relatorios/Index";
import EditOwnerPage from "@/pages/proprietarios/[id].edit";
import NovoImovel from "@/pages/imoveis/novo";
import NovoProprietario from "@/pages/proprietarios/novo";
import SuperAdminDashboard from "@/pages/super-admin/Index";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </ProtectedRoute>
            }
          >
            <Route index element={<Index />} />
            <Route path="proprietarios">
              <Route index element={<ProprietariosIndex />} />
              <Route path="novo" element={<NovoProprietario />} />
              <Route path=":id/editar" element={<EditOwnerPage />} />
            </Route>
            <Route path="mensagens" element={<MensagensIndex />} />
            <Route path="imoveis">
              <Route index element={<ImoveisIndex />} />
              <Route path="novo" element={<NovoImovel />} />
            </Route>
            <Route path="agendamentos" element={<AgendamentosIndex />} />
            <Route path="conexao" element={<ConexaoIndex />} />
            <Route path="configuracoes" element={<ConfiguracoesIndex />} />
            <Route path="relatorios" element={<RelatoriosIndex />} />
            <Route path="super-admin" element={<SuperAdminDashboard />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;